<template>
  <div class="container-fluid mt--7">
    <div class="row">
      <div class="col-sm-6">
        <div class="card shadow">
          <div class="card-header bg-transparent">
            <h6>INSS Cooperado</h6>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="cnpjEmpresa">CNPJ Empresa:</label>
                  <cnpj :id="'cnpjEmpresa'"/>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label for="nomeEmpresa">Nome Empresa:</label>
                  <input type="text" class="form-control" id="nomeEmpresa">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="inicioVigencia">Inicio Vigência:</label>
                  <competencia :id="'inicioVigencia'"/>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label for="fimVigencia">Fim Vigência:</label>
                  <competencia :id="'fimVigencia'"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="valorRemuneracao">Valor Remuneração Base INSS:</label>
                  <money :id="'valorRemuneracao'"/>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label for="valorRetencaoINSS">Valor Retenção INSS:</label>
                  <money :id="'valorRetencaoINSS'"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="cooperativa">Cooperativa Responsável:</label>
                  <select class="form-control" id="cooperativa">
                    <option>Copimef</option>
                    <option>Unicooper</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="custom-control custom-checkbox mb-3">
                  <input type="checkbox" class="custom-control-input" id="liAceito">
                  <label
                    class="custom-control-label"
                    for="liAceito"
                  >Li e aceito os termos de responsabilidade</label>
                </div>
              </div>
            </div>
            <br>
            <button class="btn btn-outline-dark">
              <li class="oi oi-ban"></li>Limpar
            </button>
            <button class="btn btn-secondary">
              <li class="oi oi-check"></li>Salvar
            </button>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="card shadow">
          <div class="card-header bg-transparent">
            <h6>Lista de Declarações Cadastradas</h6>
          </div>
          <div class="card-body">teste</div>
        </div>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-sm-6">
        <div class="card shadow">
          <div class="card-header bg-transparent">Declaração Outras Empresas</div>
          <div class="card-body">
            <div class="form-group">
              <label for="cnpjEmpresa">CNPJ Empresa:</label>
              <input
                type="text"
                class="form-control input-mask"
                data-mask="000.000.000.0000"
                id="cnpjEmpresa"
                placeholder="CNPJ Empresa"
              >
            </div>
            <div class="form-group">
              <label for="nomeEmpresa">Nome Empresa:</label>
              <input type="text" class="form-control" id="nomeEmpresa" placeholder="Nome Empresa">
            </div>
            <div class="form-group">
              <label for="valorRemuneracao">Valor Remuneração Base INSS:</label>
              <input
                type="text"
                class="form-control"
                id="valorRemuneracao"
                placeholder="Valor Remuneração Base INSS"
              >
            </div>
            <div class="form-group">
              <label for="valorRetencaoINSS">Valor Retenção INSS:</label>
              <input
                type="text"
                class="form-control"
                id="valorRetencaoINSS"
                placeholder="Valor Retenção INSS"
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="card shadow">
          <div class="card-header bg-transparent">Lista de Declarações Cadastradas</div>
          <div class="card-body">Gráfico</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import money from "./utils/InputMoney";
import competencia from "./utils/InputCompetencia";
import cnpj from "./utils/InputCnpj";
export default {
  name: "Header",
  components: { money: money, competencia: competencia, cnpj: cnpj },
  data() {
    return {
      price: 0.0,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false
      }
    };
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Header.vue